export default __webpack_public_path__ + "static/media/Marketing.62fec33e.png";